import React from 'react';
import CategoryPage from '../components/CategoryPage';

const PrivateOfficesPage = () => {
  return <CategoryPage categoryId="private-offices" />;
};

export default PrivateOfficesPage;